function initialState () {
  return {
    all: [],
    designall: {},
    surveytypes: [],
    surveyDesignId: [],
    relationships: {},
    questionControls: {},
    isError: false,
    logo: [],
    bg_image: [],
    query: {},
    loading: false,
    areControlsLoaded: false,
    kioskQueCounter:0,
    survey_photo_question_count: 0,
  }
}
const getters = {
  all: state => {
    let rows = state.all
    return rows
  },
  isError: state => {
    let rows = state.isError
    return rows
  },
  // designall: state => {
  //   let rows = state.designall
  //   return rows
  // },
  surveytypes: state => {
    let rows = state.surveytypes
    return rows
  },
  total: state => state.length,
  loading: state => state.loading,
  areControlsLoaded: state => state.areControlsLoaded,
  relationships: state => state.relationships,
  designall: state => state.designall,
  questionControls: state => state.questionControls,
  kioskQueCounter: state=> state.kioskQueCounter,
  photoQuestionCount:state => state.survey_photo_question_count
}
const actions = {
  // create default survey and fetch settings data
  fetchData ({ commit, state, dispatch }, data) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = data['jwt_token']
    let url = process.env.API_PATH + '/addDefaultSurvey';
    axios
      .post(
        url,
        {
          responseType: 'json',
          lang: data['lang'],
          request_id: data['requestId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setAll', response.data)
        data['in_survey_Id'] = response.data.md5_in_survey_id
        dispatch('fetchDesignData', data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },

  fetchAllSurveyTypes ({ commit, state }, data) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = data['jwt_token']
    let url = process.env.API_PATH + '/getAllSurveyTypes';
    axios
      .post(
        url,
        {
          responseType: 'json',
          lang: data['lang'],
          request_id: data['requestId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setSurveyTypes', response.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  // edit settings data
  editData ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url =
      process.env.API_PATH + '/editForm/' + sessionData['in_survey_Id']
    axios
      .put(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          request_id: sessionData['requestId'],
          in_user_survey_id: sessionData['requestId'],
          st_survey_name: state.all.st_survey_name,
          in_survey_type: state.all.in_survey_type,
          in_audit: (state.all.in_survey_type == 4) ? 0 : state.all.in_audit,
          in_loop_survey:  (state.all.in_survey_type == 4) ? 1 : state.all.in_loop_survey,
          in_question_flow: (state.all.in_survey_type == 4) ? 0 : state.all.in_question_flow,
          in_parent_survey_id: state.all.in_parent_survey_id,
          in_latest_survey_id: state.all.in_latest_survey_id,
          in_latest_version_number: state.all.in_latest_version_number,
          in_linked: state.all.in_linked,
          in_data_security: state.all.in_data_security,
          in_status: state.all.in_status,
          delete_flag: state.all.in_delete_flag
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setAll', response.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },

  // get Edit data(Survey by id)
  async getSurveyById ({ commit, state, dispatch }, sessionData) {
    if (sessionData.in_survey_Id) {
      commit('setLoading', true)
      axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
      let url = process.env.API_PATH + '/getSurveyById';
      await axios
        .post(
          url,
          {
            responseType: 'json',
            lang: sessionData['lang'],
            request_id: sessionData['requestId'],
            in_survey_Id: sessionData['in_survey_Id']
          },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        )
        .then(response => {
          if (response.data.flag) {
            commit('setAll', response.data.data[0])
            commit('setFlagMsg', response.data)
            dispatch('getSurveyDesignById', sessionData)
          } else {
            commit('setError')
            // window.location = 'http://192.168.1.100:8000/error'
          }
        })
        .catch(error => {
          // let message = error.response.data.message || error.message
        })
        .finally(() => {
          // commit('setLoading', false)
        })
    }
  },

  async getSurveyDesignById ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url =
      process.env.API_PATH +
      '/getSurveyDesignById/' +
      sessionData['in_survey_Id']
    await axios
      .post(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          in_survey_Id: sessionData['in_survey_Id'],
          request_id: sessionData['requestId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setAllDesign', response.data.data[0])
        // commit('setFlagMsg',response.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },

  // fetch design data
  fetchDesignData ({ commit, state }, data) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = data['jwt_token']
    let url = process.env.API_PATH + '/addSurveyDesign';
    let designdata = {
      logo: '',
      logo_align: 0,
      bg_image: '',
      text_color: '#000',
      button_color: '#71439b',
      button_text_color: '#fff'
    }
    axios
      .post(
        url,
        {
          responseType: 'json',
          lang: data['lang'],
          request_id: data['requestId'],
          in_survey_Id: data['in_survey_Id'],
          st_survey_design_data: designdata
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setAllDesign', response.data)
      })
      .catch(error => {
        // let message = error.response.data.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  // edit design data
  editDesignData ({ commit, state }, sessionData) {
    commit('setLoading', true)

    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url =
      process.env.API_PATH + '/editSurveyDesign/' + state.surveyDesignId
    axios
      .put(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          in_survey_Id: sessionData['in_survey_Id'],
          st_survey_design_data: state.designall,
          request_id: sessionData['requestId'],
          logo: state.logo,
          logo_ext: state.designall.logo_ext,
          bg_ext: state.designall.bg_ext,
          bg_image: state.bg_image
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        commit('setAllDesign', response.data)
      })
      .catch(error => {
        // let message = error.response.message || error.message
      })
      .finally(() => {
        commit('setLoading', false)
      })
  },
  // get question controls
  async getQuestionControls ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url = process.env.API_PATH + '/getAllControls';
    await axios
      .post(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          request_id: sessionData['requestId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        if (response.data.flag == 1) {
          commit('setQuestionControls', response.data)
        }
      })
      .catch(e => {
        // this.$awn.alert(this.$t("message.catchapiError"));
      })
  },
  // add favourites
  async addFavourite ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']

    let url = process.env.API_PATH + '/addFavourite';
    await axios
      .post(
        url,
        {
          responseType: 'json',
          lang: sessionData['lang'],
          request_id: sessionData['requestId'],
          in_control_id: sessionData['controlId']
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        if (response.data.flag == 1) {
          commit('updateQuestionControls', response.data.data)
        }
      })
      .finally(() => {
        commit('setLoading', false)
      })
      .catch(e => {})
  },
  // remove favourites
  async removeFavourite ({ commit, state }, sessionData) {
    commit('setLoading', true)
    axios.defaults.headers.common['Authorization'] = sessionData['jwt_token']
    let url = process.env.API_PATH + '/deleteFavourite';
    await axios
      .delete(
        url,
        {
          data: {
            responseType: 'json',
            lang: sessionData['lang'],
            request_id: sessionData['requestId'],
            in_control_id: sessionData['controlId']
          }
        },
        {
          headers: { 'Content-Type': 'application/json' }
        }
      )
      .then(response => {
        if (response.data.flag == 1) {
          commit('removeQuestionControls', response.data.data)
        }
      })
      .finally(() => {
        commit('setLoading', false)
      })
      .catch(e => {})
  },
  actiontoggleType1 ({ commit, dispatch }, sessionData) {
    commit('mutateType1')
    commit('mutateinSurveyType')
    dispatch('editData', sessionData)
  },
  actiontoggleType2 ({ commit, dispatch }, sessionData) {
    commit('mutateType2')
    commit('mutateinSurveyType')
    dispatch('editData', sessionData)
  },
  actiontoggleType3 ({ commit, dispatch }, sessionData) {
    commit('mutateType3')
    commit('mutateinSurveyType')
    dispatch('editData', sessionData)
  },
  actiontoggleFlow0 ({ commit, dispatch }, sessionData) {
    commit('mutateFlow0')
    dispatch('editData', sessionData)
  },
  actiontoggleFlow1 ({ commit, dispatch }, sessionData) {
    commit('mutateFlow1')
    dispatch('editData', sessionData)
  },
  setSurvey_name ({ commit, dispatch }, [value, sessionData]) {
    commit('setSurvey_name', value)
    dispatch('editData', sessionData)
  },
  setSurvey_audit ({ commit, dispatch }, sessionData) {
    commit('setSurvey_audit')
    dispatch('editData', sessionData)
  },
  setSurvey_loop ({ commit, dispatch }, sessionData) {
    commit('setSurvey_loop')
    dispatch('editData', sessionData)
  },
  setDesign_img ({ commit, dispatch }, [file, sessionData]) {
    commit('setDesign_img', file)
    dispatch('editDesignData', sessionData)
  },
  setDesign_bgimg ({ commit, dispatch }, [file, sessionData]) {
    commit('setDesign_bgimg', file)
    dispatch('editDesignData', sessionData)
  },
  rmvDesign_img ({ commit, dispatch }, sessionData) {
    commit('rmvDesign_img')
    dispatch('editDesignData', sessionData)
  },
  rmvDesign_bgimg ({ commit, dispatch }, sessionData) {
    commit('rmvDesign_bgimg')
    dispatch('editDesignData', sessionData)
  },
  updtVerte ({ commit, dispatch }, [value, sessionData]) {
    commit('updtVerte', value)
    dispatch('editDesignData', sessionData)
  },
  updtAlign ({ commit, dispatch }, [value, sessionData]) {
    commit('updtAlign', value)
    dispatch('editDesignData', sessionData)
  },
  setQuery ({ commit }, value) {
    commit('setQuery', purify(value))
  },
  resetState ({ commit }) {
    commit('resetState')
  },
  incrementQuestionCount ({ commit }) {
    commit('incrementQuestionCount')
  },
  incrementKioskQuestionCount({ commit }) {
    commit('incrementKioskQuestionCount')
  },
  incrementPhotoQuestionCount({commit}) {
    commit('incrementPhotoQuestionCount')
  },
  decrementQuestionCount ({ commit }) {
    commit('decrementQuestionCount')
  },
  decrementKioskQuestionCount({ commit }) {
    commit('decrementKioskQuestionCount')
  },
  decrementPhotoQuestionCount({commit}) {
    commit('decrementPhotoQuestionCount')
  },
  setSurvey_delete_flag ({ commit, dispatch }, [value, sessionData]) {
    commit('setSurvey_delete_flag', value)
    dispatch('editData', sessionData)
  }
}
const mutations = {
  setAll (state, items) {
    state.all = items
    if (state.all.in_survey_type == 1) {
      state.all.type1 = 1;
      state.all.type2 = 0;
      state.all.type3 = 0;
    } else if (state.all.in_survey_type == 2) {
      state.all.type1 = 0;
      state.all.type2 = 1;
      state.all.type3 = 0;
    } else if (state.all.in_survey_type == 4) {
      state.all.type1 = 0;
      state.all.type2 = 0;
      state.all.type3 = 1;
    } else {
      state.all.type1 = 1;
      state.all.type2 = 1;
      state.all.type3 = 0;
    }
  },
  setError (state) {
    state.isError = true
  },
  setFlagMsg (state, items) {
    state.all.flag = items.flag
    state.all.msg = items.msg
  },
  setSurveyTypes (state, items) {
    state.surveytypes = items.data
  },
  setAllDesign (state, items) {
    // If retrieved from editdesigndata after editing once
    if (typeof items.st_survey_design_data === 'string') {
      var item = JSON.parse(items.st_survey_design_data)
      if (!items.logoUrl) {
        items.logoUrl = item.logo
      }
      if (!items.bgUrl) {
        items.bgUrl = item.bg_image
      }

      state.designall = item
      state.designall.logo = items.logoUrl
      state.designall.bg_image = items.bgUrl
      //this.$set('state.designall', 'logo', items.logoUrl)

      state.designall.logoflag = 0
      state.designall.bgflag = 0
    }
    // If retrieved from fetchdesigndata
    else {
      // if (!items.logoUrl) { items.logoUrl = item.logo }
      // if (!items.bgUrl) { items.bgUrl = item.bg_image }
      state.designall = items.st_survey_design_data
      state.designall.logoflag = 0
      state.designall.bgflag = 0
      state.designall.logo = items.logoUrl
      state.designall.bg_image = items.bgUrl
    }
    // If logo edited then set aws s3 link
    // if (items.logoUrl != '') {
    //
    //   state.designall.logo = items.logoUrl
    // }

    // state.designall.in_survey_Id = items.in_survey_Id;\
    state.surveyDesignId = items.in_survey_design_id
    // state.all.in_survey_design_id = items.in_survey_design_id;
  },
  setQuestionControls (state, items) {
    state.questionControls = items
    state.areControlsLoaded = true
  },
  updateQuestionControls (state, items) {
    console.log(items)
    state.questionControls.data.forEach((value, index) => {
      value.control_title_details.forEach((val, pos) => {
        if (val.in_control_id == items.in_control_id) {
          state.questionControls.favouritesData.push(items)
          state.questionControls.favouritesData[
            state.questionControls.favouritesData.length - 1
          ]['control_details'] = val
        }
      })
    })
  },
  removeQuestionControls (state, items) {
    state.questionControls.favouritesData.forEach((value, index) => {
      if (value.in_control_id == items.in_control_id) {
        state.questionControls.favouritesData.splice(index, 1)
      }
    })
  },
  mutateType1 (state) {
    state.all.type1 = !state.all.type1
  },
  mutateType2 (state) {
    state.all.type2 = !state.all.type2
  },
  mutateType3 (state) {
    state.all.type3 = !state.all.type3
  },
  mutateinSurveyType (state) {
    if (state.all.type3) {
      state.all.in_survey_type = 4;
    }else if (state.all.type1 && state.all.type2) {
      state.all.in_survey_type = 3
    } else if (state.all.type1) {
      state.all.in_survey_type = 1
    } else {
      state.all.in_survey_type = 2
    }
  },
  mutateFlow0 (state) {
    state.all.in_question_flow = 0
  },
  mutateFlow1 (state) {
    state.all.in_question_flow = 1
  },
  setSurvey_name (state, value) {
    state.all.st_survey_name = value
  },
  setSurvey_audit (state) {
      state.all.in_audit = !state.all.in_audit
  },
  setSurvey_loop (state) {
      state.all.in_loop_survey = !state.all.in_loop_survey
  },
  setDesign_img (state, file) {
    state.designall.logoflag = 1
    state.logo = file.dataUrl
    state.designall.logo_oldext = state.designall.logo_ext
    state.designall.logo_ext = file.name
    state.designall.logo_ext = state.designall.logo_ext.substring(
      state.designall.logo_ext.indexOf('.') + 1
    )
    state.designall.logo = file.dataUrl
  },
  setDesign_bgimg (state, file) {
    state.designall.bgflag = 1
    state.bg_image = file.dataUrl
    state.designall.bg_oldext = state.designall.bg_ext
    state.designall.bg_ext = file.name
    state.designall.bg_ext = state.designall.bg_ext.substring(
      state.designall.bg_ext.indexOf('.') + 1
    )
    state.designall.bg_image = file.dataUrl
  },
  rmvDesign_img (state) {
    state.logo = '';
    state.designall.logo = '';
    state.designall.logoflag = 2
    state.designall.logo_oldext = state.designall.logo_ext
    state.designall.logo_ext = '';
  },
  rmvDesign_bgimg (state) {
    state.bg_image = '';
    state.designall.bgflag = 2
    state.designall.bg_image = '';
    state.designall.bg_oldext = state.designall.bg_ext
    state.designall.bg_ext = '';
  },
  updtVerte (state, val) {
    state.designall[val.target.id] = val.target.value
  },
  updtAlign (state, val) {
    if (val.target.id == 'align-left') {
      state.designall.logo_align = 0
    } else if (val.target.id == 'align-center') {
      state.designall.logo_align = 1
    } else {
      state.designall.logo_align = 2
    }
  },
  setLoading (state, loading) {
    state.loading = loading
  },
  setQuery (state, query) {
    state.query = query
  },
  resetState (state) {
    state = Object.assign(state, initialState())
  },
  incrementQuestionCount (state) {
    state.all.survey_question_detail_count += 1;
  },
  incrementPhotoQuestionCount(state){
    state.survey_photo_question_count +=1;
  },
  incrementKioskQuestionCount(state){
    state.kioskQueCounter +=1
  },
  decrementQuestionCount (state) {
    state.all.survey_question_detail_count -= 1;
  },
  decrementPhotoQuestionCount(state){
    state.survey_photo_question_count -=1;
  },
  decrementKioskQuestionCount(state){
    state.kioskQueCounter -=1
  },
  setSurvey_delete_flag (state, val) {
    state.all.in_delete_flag = val
  }
}
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/LeftSidebar/create.js